import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { HistoryLogsDialogComponent } from 'src/app/core/dialogs/history-logs-dialog/history-logs-dialog.component';
import { BtnCellRendererDeleteClipboard } from 'src/app/core/grid/btn-cell-render-delete-clipboard';
import { ExcelService } from 'src/app/service/excel.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { HistoryService } from 'src/app/service/management/history.service';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false
})
export class HistoryComponent implements OnInit {
  gridApi: any;
  icons;
  columnDefs = [];
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;

  selected_period_id;
  selected_period_value;
  defaultColDef;
  successMessage
  errorMessage
  isAccessible = true;
  constructor(private readonly router: Router, public dialog: MatDialog,
    private readonly excelService : ExcelService, private readonly historyService: HistoryService,
    private readonly constants: Constants, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly groupIStateService : GroupIStateService) {
    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true ,suppressCellSelection: true
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.columnDefs = [
      {
        headerName: "ID", field: "queueId", sortable: true, unSortIcon: true, autoHeight: true, width: 60
      },
      {
        headerName: "Tier", field: "tier", sortable: true, unSortIcon: true, cellClass: "left_align", floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: "Round", field: "round", autoHeight: true, sortable: true, unSortIcon: true, width: 80
      },
      {
        headerName: "Created", field: "createdTime", sortable: true, unSortIcon: true, comparator: this.dateComparator
      },
      {
        headerName: "Completed", field: "completedTime", sortable: true, unSortIcon: true, comparator: this.dateComparator
      }, 
      {
        headerName: "Status", field: "addToQueueStatus", sortable: true, unSortIcon: true,
        floatingFilterComponentParams: { suppressFilterButton: true }, filter: 'agTextColumnFilter',
      }, 
      {
        headerName: "Completed By", field: "completedByUser", cellClass: "left_align", 
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
      },
      {
        headerName: "Actions", field: "history_deleteclipboard",
         cellRenderer: BtnCellRendererDeleteClipboard, width: 80
      }];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);

  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) {  // NOSONAR
      return 0;
    }
    if (date1Number == null) {  // NOSONAR
      return -1;
    }
    if (date2Number == null) {  // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }
  
  componentEventHandler(event) {

    if (event.eventType == "NOTIFICATION_ERROR") {  // NOSONAR
      this.errorMessage = event.eventMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    } else if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selected_period_id = event.periodId
      this.selected_period_value = event.periodValue
      this.refreshData();
    }
  }

  refreshData() {
    if (this.selected_period_id) {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.historyService.loadDataHistory(this.selected_period_id).subscribe(
        response => {
          this.displayRowData = response
          this.syncGridWithArrayData();
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );
    }

  }
  syncGridWithArrayData() {
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.rowCount = this.displayRowData.length;
    this.gridApi?.setFilterModel(model);
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  deleteTemplateRow(data, pagename) {
    let displayRowIndex;
    if (pagename == 'history_deleteclipboard') { // NOSONAR

      const dialogRef = this.dialog.open(
        DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '170px',
        data: {
          header: 'Are you sure you want to delete this History Log?',
          description: data.queueId + " - " + data.tier,
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'ConfirmEvent') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.historyService.deleteHistoryRecord(this.selected_period_id, data.queueId).subscribe(
            response => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              if (response == "Success") {  // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTime);
                displayRowIndex = this.displayRowData.findIndex(x => x.queueId == data.queueId) // NOSONAR
                this.displayRowData.splice(displayRowIndex, 1);
                this.gridApi?.setGridOption('rowData', this.displayRowData)
                this.rowCount = this.displayRowData.length;
              }
            }, _error => {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
          );
        }
      });

    }
  }

  clipboardTemplateRow(data, pagename) {
    if (pagename == 'history_deleteclipboard') {  // NOSONAR

      const dialogRef = this.dialog.open(
        HistoryLogsDialogComponent, {
        disableClose: true,
        width: '800px',
        height: '374px',
        data: {
          eventType: 'VIEWLOGS',
          queueId: data.queueId
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'CloseEvent') { // NOSONAR
          console.info(result)
         }
      });

    }
  }
  exportHistory() {
      if (this.displayRowData?.length > 0) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            period: this.selected_period_value,
            tier: e.tier,
            round: e.round,
            created: e.created,
            completed: e.completed,
            status : e.status,
            completedby: e.completedBy,
          };
          exportData.push(obj);
        });
        const headers = ['Period', 'Tier', 'Round', 'Created', 'Completed', 'Status','Completed By'];
        this.excelService.exportAsExcelFile(exportData, 'HISTORY - ' + this.selected_period_value, headers);
      }
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.data == "Success") { // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }

  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
}



function  monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 19) { // NOSONAR
    return null;
  }
  const secondNumber = Number.parseInt(date.substring(17, 19));
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const  monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 10000000000 + monthNumber * 100000000 + dayNumber * 1000000 + hourNumber * 10000 + minNumber * 100 + secondNumber;
}